//import Swiper from 'react-id-swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import styled from "@emotion/styled";
import React, {useState,useEffect,useMemo} from "react";
import Helper from "../functions/Helper.js";
/** @jsx jsx */
import {jsx} from '@emotion/core'
import Modal from 'react-bootstrap/Modal';
import StyleModal from '../components/StyleModal.js';
import SliderItem from '../components/StyleSliderItem.js';

const ArrowContainer=styled.div((props)=>{
  return(
    {
      display:"flex","@media (max-width:768px)":{display:"none"},
    }
  )
});


function ColorwaySlider(props) {
  let filteredStyles=useMemo(() => {
    if(props.shoe.hasOwnProperty("styles")){
      props.shoe.styles.forEach((style)=>{
          style.colorways=props.shoe.colorways.filter((colorway)=>colorway.style_id===style.style_id)
        })
      let availableStyles=props.shoe.styles.filter((style)=>style.colorways.length>0);
      availableStyles.sort((a,b)=>a.colorways[0].price - b.colorways[0].price === 0 ? a.style_id -b.style_id : a.colorways[0].price - b.colorways[0].price );
      return(availableStyles)
    }
    else{
      return([])
    }
  },[props.shoe]);

  const [swiper, updateSwiper] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [activeStyleId,setActiveStyleId]=useState(0);

  if(filteredStyles.length>0){
    return(
      <div className="hover-swiper" style={{width:"100%"}}>
        <Modal dialogClassName="thg_style_modal" onHide={()=>{setShowModal(false)}} show={showModal}>
          <StyleModal linkId={props.linkId} hideModal={()=>{setShowModal(false)}} changeSlide={(x)=>setActiveStyleId(x)} activeStyleId={activeStyleId} styles={filteredStyles} shoe={props.shoe}/>
        </Modal>
        <div style={{cursor:"pointer",marginBottom:20,display:"flex"}}>
          <div style={{flex:1,minWidth:0}}>
            <Swiper navigation={{nextEl: '.next-button-hover',prevEl: '.prev-button-hover'}} slidesPerView={"auto"} spaceBetween={15}>
              {filteredStyles.map((style,index)=>{
                let swiperWidth=props.type==="table" ? 160 :220;
                return(
                  <SwiperSlide key={style.style_id} style={{width:swiperWidth}}>
                    <SliderItem  showDiscount onClick={()=>{setShowModal(true);setActiveStyleId(index)}} swiperWidth={swiperWidth}  styleItem={style}/>
                  </SwiperSlide>
                )
              })}
              <div style={{top:"10%"}} className="swiper-button-next next-button-hover"/>
              <div style={{top:"10%"}}  className="swiper-button-prev prev-button-hover"/>
            </Swiper>
          </div>
        </div>
      </div>
    )
  }
  else{
    return (null)
  }

}

export default ColorwaySlider;
